import type { MaterialComponentValue, MaterialProductComponentValue } from '../../schemas';
import { getUnitOfMeasureLabel } from '../unitOfMeasure/unitOfMeasure';

const formatValue = (value: string) => {
  return Number(value).toFixed(1);
};

export const getMaterialComponentLabel = (
  materialComponent: MaterialComponentValue | MaterialProductComponentValue
) => {
  const materialComponentName = materialComponent.supported_component.component.name;

  let materialComponentValue: string | undefined = undefined;
  if (materialComponent.min_value && !materialComponent.max_value) {
    materialComponentValue = `min: ${formatValue(materialComponent.min_value)}`;
  }
  if (materialComponent.max_value && !materialComponent.min_value) {
    materialComponentValue = `max: ${formatValue(materialComponent.max_value)}`;
  }
  if (materialComponent.min_value && materialComponent.max_value) {
    materialComponentValue = `${formatValue(materialComponent.min_value)} - ${formatValue(materialComponent.max_value)}`;
  }
  if (materialComponent.boolean_value) {
    materialComponentValue = materialComponent.boolean_value ? 'Yes' : 'No';
  }

  if (!materialComponentValue) {
    return `${materialComponentName} -`;
  }

  return `${materialComponentName} ${materialComponentValue}${getUnitOfMeasureLabel(materialComponent.supported_component.component.unit)}`;
};
